<ng-container *ngrxLet="selectIsDeveloper$; let isDeveloper">
  <form [formGroup]="editLocationFormGroup"
        class="flex-col gap-24 narrower-input form-wrapper"
  >
    <div class="flex-col gap-24">
      <div class="flex-col">
        <h2>
          {{ 'ADD_LOCATION.COMPLIANCE_LABEL'|translate }}
        </h2>
        <div style="width: 350px;">
          <mat-select class="ui-selector w-100" formControlName="complianceOption">
            <mat-option *ngFor="let option of ComplianceOptionKeys"
                        [value]="option"
            >{{ ComplianceOption[option] | titlecase }}
            </mat-option>
          </mat-select>
        </div>
        <div class="compliance-description">
          {{ 'ADD_LOCATION.COMPLIANCE_DESCRIPTION'|translate }}
        </div>
      </div>
      <div class="flex-col gap-24"
           [class.disabled]="+editLocationFormGroup.get('complianceOption').value !== ComplianceOption.INDEPENDENT"
      >
        <div class="flex-col start-start gap-8">
          <div class="flex-row start-start gap-8">
            <ui-toggle formControlName="faceRecognition"></ui-toggle>
            <div class="flex-col gap-8">
              <div class="compliance-label">{{ 'ADD_LOCATION.FACE_RECOGNITION'|translate }}</div>
              <div class="compliance-description">
                {{ 'ADD_LOCATION.FACE_RECOGNITION_DESCRIPTION'|translate }}
              </div>
            </div>
          </div>

        </div>
        <div class="flex-col start-start gap-8">
          <div class="flex-row start-start gap-8">
            <ui-toggle formControlName="genderClassification"></ui-toggle>
            <div class="flex-col gap-8">
              <div class="compliance-label">{{ 'ADD_LOCATION.GENDER_INFORMATION'|translate }}</div>
              <div class="compliance-description">
                {{ 'ADD_LOCATION.GENDER_INFORMATION_DESCRIPTION'|translate }}
              </div>
            </div>
          </div>
        </div>
<!--        <div *ngIf="isDeveloper" class="flex-col gap-8">-->
<!--          <ng-container *ngrxLet="edges$; let edges">-->
<!--            <ng-container *ngrxLet="compliance$; let compliance">-->
<!--              <h2>{{ 'LOCATION_EDIT.SYNC_STATUS'|translate }}</h2>-->
<!--              <div class="flex-row space-between-center w-100" *ngFor="let edge of edges">-->
<!--                <div>-->
<!--                  {{ edge.name }}-->
<!--                </div>-->
<!--                <ng-container-->
<!--                  *ngIf="edge.complianceData?.biometricData?.faceRecognition === compliance.faceRecognition-->
<!--                    && edge.complianceData?.biometricData?.genderClassification === compliance.genderClassification;-->
<!--else notSynced"-->
<!--                >-->
<!--                  <div class="svg-fill-green icon-20">-->
<!--                    <mat-icon svgIcon="status-online"></mat-icon>-->
<!--                  </div>-->
<!--                </ng-container>-->
<!--                <ng-template #notSynced>-->
<!--                  <div class="svg-fill-red icon-20">-->
<!--                    <mat-icon svgIcon="status-offline"></mat-icon>-->
<!--                  </div>-->
<!--                </ng-template>-->
<!--              </div>-->
<!--            </ng-container>-->
<!--          </ng-container>-->

<!--        </div>-->
      </div>
      <div class="flex-col">
        <h2>
          {{ 'ADD_LOCATION.CONFIGURATION_LABEL'|translate }}
        </h2>
        <div style="width: 350px;">
          <mat-select class="ui-selector w-100" formControlName="networkProfile">
            <mat-option [value]="NetworkProfile.HighQuality">{{ 'CAMERA_EDIT_CONFIGURATION.HIGH_QUALITY' | translate }}</mat-option>
            <mat-option [value]="NetworkProfile.LowBandwidth">{{ 'CAMERA_EDIT_CONFIGURATION.LOW_BANDWIDTH' | translate }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </form>
</ng-container>
